// Ícones ultra-avançados
import { useState, useEffect, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import "moment/locale/pt-br";
import "./style.css";
import axios from "axios";

const ARIcon = () => (<svg width="24" height="24" fill="currentColor"><circle cx="12" cy="12" r="10"/><text x="7" y="17" fontSize="10" fill="#fff">AR</text></svg>);
const ChallengeIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="4" width="16" height="16" rx="4"/><text x="6" y="17" fontSize="10" fill="#fff">🏆</text></svg>);
const LiveIcon = () => (<svg width="24" height="24" fill="red"><circle cx="12" cy="12" r="10"/><text x="7" y="17" fontSize="10" fill="#fff">LIVE</text></svg>);
const PrivacyIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="8" width="16" height="10" rx="2"/><circle cx="12" cy="13" r="3" fill="#fff"/></svg>);
const NotificationIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6V11c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-1.7 1.7c-.14.14-.3.33-.3.6V19h16v-1.7c0-.27-.16-.46-.3-.6L18 16z"/></svg>);
const ModerationIcon = () => (<svg width="24" height="24" fill="orange"><rect x="4" y="4" width="16" height="16" rx="2"/><text x="6" y="17" fontSize="10" fill="#fff">MOD</text></svg>);
const APIIcon = () => (<svg width="24" height="24" fill="blue"><rect x="4" y="4" width="16" height="16" rx="2"/><text x="6" y="17" fontSize="10" fill="#fff">API</text></svg>);
  // Ultra-avançados
  const handleAR = (reel) => {
    alert("Abrir efeitos AR para este vídeo (integração WebAR/Snap)");
    // Exemplo: window.open(`/ar?postId=${reel._id}`);
  };
  const handleChallenge = (reel) => {
    alert("Participar ou criar desafio para este vídeo");
    // Exemplo: window.open(`/challenge?postId=${reel._id}`);
  };
  const handleLive = (reel) => {
    alert("Iniciar ou assistir live deste usuário");
    // Exemplo: window.open(`/live?userId=${reel.user._id}`);
  };
  const handlePrivacy = (reel) => {
    alert("Configurar privacidade granular deste post");
    // Exemplo: abrir modal de privacidade
  };
  const handleNotification = (reel) => {
    alert("Gerenciar notificações em tempo real deste post");
    // Exemplo: abrir painel de notificações
  };
  const handleModeration = (reel) => {
    alert("Ver status de moderação automática/manual deste post");
    // Exemplo: abrir painel de moderação
  };
  const handleAPI = (reel) => {
    alert("Importar ou integrar com APIs externas para este post");
    // Exemplo: abrir painel de integração
  };

const StarIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>);
const FlagIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M4 4h16v2H4zm0 4h10v2H4zm0 4h16v2H4zm0 4h10v2H4z"/></svg>);
const RemixIcon = () => (<svg width="24" height="24" fill="currentColor"><circle cx="12" cy="12" r="10"/><path d="M8 12h8M12 8v8" stroke="#fff" strokeWidth="2"/></svg>);
const DuetIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="4" width="7" height="16"/><rect x="13" y="4" width="7" height="16"/></svg>);
const SoundIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/></svg>);
const TemplateIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M4 9h16" stroke="#fff" strokeWidth="2"/></svg>);
const RepostIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M17 1l4 4-4 4V6H3V4h14V1zM7 23l-4-4 4-4v3h14v2H7v3z"/></svg>);
const AnalyticsIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="10" width="3" height="10"/><rect x="10" y="4" width="3" height="16"/><rect x="16" y="7" width="3" height="13"/></svg>);

export default function ReelsFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef(null);
  const videoRefs = useRef({});

  // Handlers avançados

  // Handlers avançados
  const fetchReels = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/feed/reels?limit=30`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setReels(data.posts || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Reels:", error);
      setLoading(false);
    }
  };

  const handleFavorite = async (reelId) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/favoritePost`,
        { postId: reelId },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      setReels((prev) => prev.map((r) => r._id === reelId ? { ...r, isFavorited: !r.isFavorited } : r));
    } catch (e) { alert("Erro ao favoritar"); }
  };

  const handleReport = async (reelId) => {
    const motivo = prompt("Descreva o motivo da denúncia:");
    if (!motivo) return;
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/reportPost`,
        { postId: reelId, reason: motivo },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      alert("Denúncia enviada!");
    } catch (e) { alert("Erro ao denunciar"); }
  };

  const handleRemix = (reel) => {
    // Redirecionar para tela de criação de remix
    window.location.href = `/remix?postId=${reel._id}`;
  };
  const handleDuet = (reel) => {
    window.location.href = `/duet?postId=${reel._id}`;
  };
  const handleUseSound = (reel) => {
    window.location.href = `/create?soundId=${reel.tiktokData?.soundId}`;
  };
  const handleUseTemplate = (reel) => {
    window.location.href = `/create?templateId=${reel.tiktokData?.templateId}`;
  };
  const handleRepost = async (reelId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/repostPost`,
        { postId: reelId },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      alert("Reel republicado!");
    } catch (e) { alert("Erro ao republicar"); }
  };
  const handleAnalytics = async (reelId) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/postAnalytics/${reelId}`,
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      alert("Visualizações: " + data.views + " | Curtidas: " + data.likes);
    } catch (e) { alert("Erro ao buscar analytics"); }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchReels();
  }, []);

  // Handle scroll snap to detect current reel
  const handleScroll = useCallback(() => {
    if (containerRef.current) {
      const scrollTop = containerRef.current.scrollTop;
      const height = window.innerHeight;
      const index = Math.round(scrollTop / height);

      if (index !== currentIndex && index >= 0 && index < reels.length) {
        setCurrentIndex(index);
      }
    }
  }, [currentIndex, reels.length]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  // Auto-play current video, pause others
  useEffect(() => {
    Object.entries(videoRefs.current).forEach(([index, video]) => {
      if (video) {
        if (parseInt(index) === currentIndex) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  }, [currentIndex]);

  const togglePlay = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  };

  const toggleMute = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      video.muted = !video.muted;
    }
  };

  const handleLike = async (reelId) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/reactPost`,
        { postId: reelId, react: "like" },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setReels((prev) =>
        prev.map((reel) =>
          reel._id === reelId
            ? { ...reel, isLiked: !reel.isLiked }
            : reel
        )
      );
    } catch (error) {
      console.error("Error liking reel:", error);
    }
  };

  if (loading) {
    return (
      <div className="reels_feed_loading">
        <div className="reels_loader"></div>
      </div>
    );
  }

  if (reels.length === 0) {
    return (
      <div className="reels_feed_empty">
        <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
          <path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>
        </svg>
        <h3>Nenhum Reel encontrado</h3>
        <p>Seja o primeiro a criar um Reel!</p>
      </div>
    );
  }

  return (
    <div className="reels_feed" ref={containerRef}>
      {reels.map((reel, index) => (
        <div key={reel._id} className="reels_item">
          {/* Video */}
          <div className="reels_video_container" onClick={() => togglePlay(index)}>
            {reel.videos?.[0] ? (
              <video
                ref={(el) => (videoRefs.current[index] = el)}
                src={reel.videos[0].url || reel.videos[0]}
                loop
                muted
                playsInline
                className="reels_video"
              />
            ) : reel.images?.[0] ? (
              <img
                src={reel.images[0].url || reel.images[0]}
                alt=""
                className="reels_image"
              />
            ) : (
              <div className="reels_placeholder">
                <svg viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
                  <path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>
                </svg>
              </div>
            )}
            <div className="reels_gradient" />
          </div>


          {/* Side Actions - AVANÇADO */}
          <div className="reels_actions">
            <Link to={`/profile/${reel.user.username}`} className="reels_avatar">
              <img src={reel.user.picture} alt="" />
              <div className="reels_follow_btn">+</div>
            </Link>

            {/* Curtir */}
            <button className={`reels_action_btn ${reel.isLiked ? "liked" : ""}`} onClick={() => handleLike(reel._id)}>
              <svg viewBox="0 0 24 24" fill={reel.isLiked ? "#fe2c55" : "none"} stroke="currentColor" strokeWidth="2" width="28" height="28">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
              <span>{reel.reactions?.length || 0}</span>
            </button>

            {/* Favoritar */}
            <button className={`reels_action_btn ${reel.isFavorited ? "favorited" : ""}`} onClick={() => handleFavorite(reel._id)}>
              <StarIcon />
              <span>{reel.favorites?.length || 0}</span>
            </button>

            {/* Reportar */}
            <button className="reels_action_btn" onClick={() => handleReport(reel._id)}>
              <FlagIcon />
            </button>

            {/* Remix */}
            <button className="reels_action_btn" onClick={() => handleRemix(reel)} title="Remixar">
              <RemixIcon />
            </button>

            {/* Duet */}
            <button className="reels_action_btn" onClick={() => handleDuet(reel)} title="Duet">
              <DuetIcon />
            </button>

            {/* Usar Som */}
            <button className="reels_action_btn" onClick={() => handleUseSound(reel)} title="Usar Som">
              <SoundIcon />
            </button>

            {/* Usar Modelo */}
            <button className="reels_action_btn" onClick={() => handleUseTemplate(reel)} title="Usar Modelo">
              <TemplateIcon />
            </button>

            {/* Republicar */}
            <button className="reels_action_btn" onClick={() => handleRepost(reel._id)} title="Republicar">
              <RepostIcon />
            </button>

            {/* Analytics */}
            <button className="reels_action_btn" onClick={() => handleAnalytics(reel._id)} title="Analytics">
              <AnalyticsIcon />
            </button>


            {/* AR */}
            <button className="reels_action_btn" onClick={() => handleAR(reel)} title="Efeitos AR">
              <ARIcon />
            </button>

            {/* Desafio */}
            <button className="reels_action_btn" onClick={() => handleChallenge(reel)} title="Desafio">
              <ChallengeIcon />
            </button>

            {/* Live */}
            <button className="reels_action_btn" onClick={() => handleLive(reel)} title="Live">
              <LiveIcon />
            </button>

            {/* Privacidade */}
            <button className="reels_action_btn" onClick={() => handlePrivacy(reel)} title="Privacidade">
              <PrivacyIcon />
            </button>

            {/* Notificações */}
            <button className="reels_action_btn" onClick={() => handleNotification(reel)} title="Notificações">
              <NotificationIcon />
            </button>

            {/* Moderação */}
            <button className="reels_action_btn" onClick={() => handleModeration(reel)} title="Moderação">
              <ModerationIcon />
            </button>

            {/* APIs externas */}
            <button className="reels_action_btn" onClick={() => handleAPI(reel)} title="APIs externas">
              <APIIcon />
            </button>

            {/* Mute */}
            <button className="reels_action_btn" onClick={() => toggleMute(index)}>
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
              </svg>
            </button>

            {reel.tiktokData?.musicTitle && (
              <div className="reels_music_disc">
                <img src={reel.user.picture} alt="" />
              </div>
            )}
          </div>
          <div className="reels_info">
            <Link to={`/profile/${reel.user.username}`} className="reels_author">
              <span className="reels_username">{reel.user.username}</span>
              <span className="reels_verified">
                <svg viewBox="0 0 24 24" fill="#3897f0" width="14" height="14">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </span>
            </Link>

            <p className="reels_caption">
              {reel.text || reel.tiktokData?.hashtags?.map((h) => `#${h}`).join(" ")}
            </p>

            {reel.tiktokData?.musicTitle && (
              <div className="reels_music">
                <svg viewBox="0 0 24 24" fill="currentColor" width="12" height="12">
                  <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
                </svg>
                <span className="reels_music_scroll">
                  {reel.tiktokData.musicTitle} - {reel.tiktokData.musicArtist || reel.user.first_name}
                </span>
              </div>
            )}

            <div className="reels_time">
              <Moment fromNow locale="pt-br">{reel.createdAt}</Moment>
            </div>
          </div>

          {/* Progress Indicator */}
          <div className="reels_progress">
            {reels.slice(0, 10).map((_, i) => (
              <div
                key={i}
                className={`reels_progress_dot ${i === currentIndex ? "active" : ""}`}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
